var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import GridSection from '@marketing/components/sections/GridSection';
import useTicker from '@marketing/useTicker';
import { clsx } from 'clsx';
import IconItem from './Items/IconItem';
export var RTBBackgroundColor;
(function (RTBBackgroundColor) {
    RTBBackgroundColor["BACON"] = "bg-surface-bacon";
    RTBBackgroundColor["DARK_RED"] = "bg-deco-dark-red";
    RTBBackgroundColor["BROWN"] = "bg-deco-brown";
    RTBBackgroundColor["LIGHT_BLUE"] = "bg-[#9BCBEB]";
    RTBBackgroundColor["DARK_BLUE"] = "bg-deco-dark-blue";
    RTBBackgroundColor["LIGHT_PINK"] = "bg-deco-light-pink";
    RTBBackgroundColor["SQUASH"] = "bg-action-surface-primary";
    RTBBackgroundColor["GREEN"] = "bg-deco-green";
})(RTBBackgroundColor || (RTBBackgroundColor = {}));
function RTB(_a) {
    var content = _a.content;
    var rtbItems = content.rtbItems, tickerText = content.tickerText, backgroundColor = content.backgroundColor, _b = content.theme, theme = _b === void 0 ? 'light' : _b;
    return useTicker(_jsx(GridSection, __assign({ numCols: 2, paddingStyle: "px-sm-m py-xl-m md:px-3xl-gutter md:pb-md-page-bottom-web md:pt-[60px]", gapStyle: "gap-y-[60px]", className: "md:max-w-2xl md:mx-auto", backgroundColorStyle: backgroundColor }, { children: rtbItems.map(function (item, index) { return (_jsx("div", __assign({ className: clsx('justify-self-start md:justify-self-center', index % 2 === 0 ? 'md:!justify-self-start' : 'md:!justify-self-end') }, { children: _jsx(IconItem, __assign({}, item), index) }), index)); }) })), tickerText, backgroundColor, theme);
}
export default RTB;
